<template>
  <dashboard-chart-card
    title="Resumen de estado de tickets"
    @handleDownloadClick="$emit('handleDownload')"
  >
    <template #info>
      <a-popover
        trigger="hover"
        class="popover"
        placement="bottomRight"
        :overlayStyle="{ width: '250px' }"
      >
        <template #title> <span class="titlePopover">Estado de tickets</span></template>
        <template #content>
          <div class="content">
            <span> Visualiza y descarga el estado de los tickets en la plataforma. </span>
            <p class="separator"></p>

            <span class="subtitle">En cola:</span>
            <span> Tickets que están a la espera de asignación a un usuario. </span>
            <p class="separator"></p>

            <span class="subtitle">Asignado:</span>
            <span> Tickets que tienen un usuario asignado. </span>
            <p class="separator"></p>

            <span class="subtitle">Resuelto:</span>
            <span> Tickets que han sido marcados como resueltos por un usuario. </span>
          </div>
        </template>
        <InfoCircleOutlined class="info-circle" />
      </a-popover>
    </template>

    <div>
      <LineDateChartSummaryState :data="chartData" />
    </div>
  </dashboard-chart-card>
</template>

<script>
import LineDateChartSummaryState from "@/app/dashboard/components/charts/LineDateChartSummaryState.vue";
import DashboardChartCard from "../cards/DashboardChartCard.vue";
import { defineComponent } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  components: {
    DashboardChartCard,
    LineDateChartSummaryState,
    InfoCircleOutlined,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    hourRange: {
      required: true,
      type: Object,
    },
  },
  computed: {
    chartData() {
      return {
        tickets_states: this.mapData(this.data?.tickets_states),
      };
    },
  },
  methods: {
    mapData(data) {
      if (!data) return [];

      const hasHourRange = Object.values(this.hourRange).length !== 0;

      const mappedData = [];
      for (const key in hasHourRange ? this.hourRange : data) {
        const axis = {};
        axis[key.length > 2 ? "date" : "hour"] = key;
        axis.data = data[key] || [];
        mappedData.push(axis);
      }

      return mappedData;
    },
    handleChange(payload) {
      this.date_start = payload.date_start;
      this.date_end = payload.date_end;
    },
  },
});
</script>

<style lang="sass" scoped>
:deep(.ant-select)
  width: 280px

.queue__width
  width: 150px
.margin-botton
  margin-bottom: 2px
  color: $gray-8

.popover
  margin-right: 20px

.info-circle
  font-size: 14px
  color: #51555A

.content
  font-weight: 300
  color: $gray-8

.titlePopover
  font-size: 16px
  font-weight: 600

.separator
  margin-top: 2px
  margin-bottom: 2px

.subtitle
  color: $gray-8
  font-weight: 600
</style>
